export default "__VITE_ASSET__Cy8Xm8DN__"